import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalRef } from '../../shared/globals/global-ref';
import { IEntityValidation } from '../../shared/interfaces/models/ientity-validation.model';
import { IPageableList } from '../../shared/interfaces/models/ipageable-list.model';
import { DictionaryBaseService } from '../../shared/services/dictionary-base.service';
import { UserContextService } from '../../shared/services/user-context.service';
import { IGroupQuery } from './igroup-query.model';
import { IGroup } from './igroup.model';
import { AppSettings } from '../../shared/models/appsettings';

@Injectable({
  providedIn: 'root',
})
export class GroupsService extends DictionaryBaseService<IGroup> {

  constructor(globalContext: GlobalRef, protected userContextSvc: UserContextService, protected http: HttpClient) {
    super(globalContext, userContextSvc, http);
    this.svcUrl += "Groups/"; 
  }

  getCOECGroup(bfId: number): Observable<IGroup> {
    return this.http.get<IGroup>(this.svcUrl + 'GetCOECGroup?bfId=' + bfId);
  }

  getMRECGroup(orgunitId: number, bfId: number): Observable<IGroup> {
    return this.http.get<IGroup>(this.svcUrl + 'GetOUECGroup?orgunitId=' + orgunitId + '&bfId=' + bfId);
  }  

  addMember(groupId: number, login: string): Observable<number> {
    return this.http.post<number>(this.svcUrl + `AddMember?groupId=${groupId}&login=${login}`, {});
  }

  removeMember(groupId: number, userId: number): Observable<void> {
    return this.http.post<void>(this.svcUrl + `RemoveMember?groupId=${groupId}&userId=${userId}`, {});
  }

  addHROrgPosition(groupId: number, positionId: number, positionTitle: string): Observable<number> {
    return this.http.post<number>(this.svcUrl + `addHROrgPosition?groupId=${groupId}&positionId=${positionId}&positionTitle=${positionTitle}`, {});
  }

  removeHROrgPosition(groupId: number, positionId: number): Observable<void> {
    return this.http.post<void>(this.svcUrl + `RemoveMember?groupId=${groupId}&positionId=${positionId}`, {});
  }

  validate(model: IGroup): IEntityValidation {
    let res: IEntityValidation = { Valid: true };
    let valid = !(!model.Title
      || !model.TypeId
      || !(!model.HROrgPositionsBFsSyncEnabled || (model.HROrgPositionsBFsSyncEnabled && model.HROrgPositions.length > 0 && model.HROrgPositions.length > 0))
    );
    if (!valid) {
      res.Valid = false;
      res.Message = 'Не заполнены обязательные поля';
      return res;
    }
    return res;
  }

  loadExpertGroups(): Promise<IPageableList<IGroup>> {
    let query: IGroupQuery = {}
    query.Skip = 0;
    query.Take = AppSettings.idea.dictionariesLoadLimit;
    query.IsDeleted = false;
    return this.fetchPaged(query).toPromise();
  }

}
